import * as React from 'react';
import * as ReactDOMServer from 'react-dom/server';
import { IMapCoordinates, IMapGeoObject } from '@cian/frontend-newbuilding-map-component';
import { EInfrastructureType, INFRASTRUCTURE_MAP_ICON } from '../utils';
import { MapPin } from '../../../components/Infrastructure';

interface IGetGeoObjectProps {
  id: string;
  type: EInfrastructureType;
  coordinates: IMapCoordinates;
}

export const getGeoObject = ({ id, type, coordinates }: IGetGeoObjectProps) => {
  const size = type === EInfrastructureType.Main ? 54 : 32;
  const IconComponent = INFRASTRUCTURE_MAP_ICON[type];

  const geoObject: IMapGeoObject = {
    type: 'Point',
    name: type,
    options: {
      id,
      coordinates,
      width: size,
      height: size,
      html: ReactDOMServer.renderToStaticMarkup(
        <MapPin type={type} icon={<IconComponent color="icon-inverted-default" />} />,
      ),
    },
  };

  if (type !== EInfrastructureType.Main) {
    geoObject.options.yOffset = -size / 2;
  }

  return geoObject;
};
